export const MOCK_RESPONSE_PUT_CONTENTS_RATING = {
  contentId: 'string',
  userId: 'string',
  score: 5,
  comment: 'string',
  createdAt: '2025-12-19T16:10:26.638Z',
  updatedAt: '2025-12-19T16:10:26.638Z',
};
